import { adapter, initialState, State } from './los-discount.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  AddLosDiscountComplete,
  DeleteLosDiscountComplete,
  DeleteMultipleLosDiscountComplete,
  GetLosDiscountComplete,
  LoadLosDiscountsComplete,
} from './los-discount.actions'
import { upsertMany } from '@tokeet-frontend/utility'

// Internal reducer created via NgRx helper. Not exported to avoid AOT issues.
const reducer = createReducer(
  initialState,
  on(LoadLosDiscountsComplete, (state, { items }) => upsertMany(adapter, items, { ...state, isLoaded: true })),
  on(AddLosDiscountComplete, (state, { item }) => adapter.addOne(item, state)),
  on(GetLosDiscountComplete, (state, { item }) => adapter.setOne(item, state)),
  on(DeleteLosDiscountComplete, (state, { id }) => adapter.removeOne(id, state)),
  on(DeleteMultipleLosDiscountComplete, (state, { ids }) => adapter.removeMany(ids, state))
)

// AOT-friendly exported reducer function for StoreModule.forFeature
export function losDiscountReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
